import { render } from "./ZHTransactionRecordHistoryTab.vue?vue&type=template&id=d7349d68&scoped=true"
import script from "./ZHTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
export * from "./ZHTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d7349d68"

export default script